/* eslint-disable no-unused-vars */
import axios from "../../axios";

export default {
  namespaced: true,
  state: {
    curriculums: [],
    curriculumsCourse: [],
  },
  mutations: {
    SET_LIST(state, data) {
      state.curriculums = data;
    },
    SET_LIST_BY_COURSE(state, data) {
      state.curriculumsCourse = data;
    },
  },
  actions: {
    async getCurriculums({ commit }, query) {
      return new Promise((resolve, reject) => {
        axios
          .get(`curriculums/overview?${new URLSearchParams(query)}`)
          .then((response) => {
            commit("SET_LIST", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async getCurriculumsCourse({ commit }, { course_id, query }) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `curriculums/overview/${course_id}?${new URLSearchParams(query)}`
          )
          .then((response) => {
            commit("SET_LIST_BY_COURSE", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {},
};
